import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { getDynamicDataList } from '../../../../services/api';
import Observer from '@researchgate/react-intersection-observer';
import styles from './index.css';
import Module from '../../module';

class News extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        dataListArr: [],
    };

    async getDataListFn() {
        try {
            const dataListArr = await getDynamicDataList('3-35191-', 19);

            this.setState({
                dataListArr,
            });
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (event, unobserve) => {
        const { content } = this.props;
        const { isAsync } = content;

        if (event.isIntersecting) {
            unobserve();
            if (isAsync) {
                this.getDataListFn();
            }
        }
    };

    render() {
        const { content } = this.props;
        const { dataListArr } = this.state;
        const { newsMd, newsSlide, newsAd, newsAllFeedData, isAsync } = content;

        let normalTabsData = (newsMd && newsMd.moduleTh) || '';
        const viewMoreLinkData = (newsMd && newsMd.moreTh) || '';
        const newsStreamData = isAsync ? dataListArr : newsAllFeedData;
        const mdBannerData = newsSlide;

        if (normalTabsData) {
            normalTabsData.chipConfig = {
                id: '50144',
                type: 'struct',
                title: '资讯模块头数据',
                groupName: 'content',
                translate: 'handleHomeNewSubInfo',
            };

            if (normalTabsData.subTit && normalTabsData.subTit.length > 0) {
                normalTabsData.subTit = normalTabsData.subTit.map((item, index) => {
                    let clickConfig = undefined;

                    if (item.title === '客户端') {
                        clickConfig = {
                            behavior: 'action',
                            type: 'openapp_info',
                        };
                    }

                    return {
                        title: item.title,
                        url: item.url,
                        clickConfig,
                    };
                });
            }
        }

        const moduleData = {
            normalTabsData,
            feedAd: newsAd,
            mdBannerData,
            newsStreamData,
            viewMoreLinkData,
            showNum: 11,
            stepNum: 4,
            countNum: 19,
        };

        return (
            <Observer onChange={this.handleChange}>
                <section className={styles.news}>
                    <Module content={moduleData} />
                </section>
            </Observer>
        );
    }
}

export default errorBoundary(News);
